import type { AlarmClosedReason, AlarmInbox, AlarmInboxEntry } from '../api/types'

/** An event is unchecked for a person until they check it, and again when it
 *  rises to Alarm after their check. */
export const alarmUnchecked = (entry: AlarmInboxEntry): boolean =>
  !entry.checked_at || Boolean(entry.escalated_at && entry.checked_at < entry.escalated_at)

/** What an ended event says. "Resolved" is only for an alarm that cleared on
 *  its own; a rule switched off or changed did not resolve anything. */
export function closedWording(reason: AlarmClosedReason | null): string {
  if (reason === 'clear') return 'Resolved'
  if (reason === 'rule off') return 'Rule switched off'
  if (reason === 'rule changed') return 'Rule changed'
  return 'Closed'
}

/** The bell's badge: nothing while the first answer is on its way (never a
 *  0 that means "not asked yet"), "!" when it could not be asked, otherwise
 *  the number still to check. */
export function bellBadge(inbox: AlarmInbox | undefined, failed: boolean): string | null {
  if (!inbox) return failed ? '!' : '…'
  return inbox.unchecked > 0 ? String(inbox.unchecked) : null
}

export function bellLabel(inbox: AlarmInbox | undefined, failed: boolean): string {
  if (!inbox) return failed ? 'Alarm notifications: could not be loaded' : 'Alarm notifications: loading'
  return `Alarm notifications: ${inbox.unchecked} to check, ${inbox.active.length} active`
}
